export const IMAGE_UPLOAD_ACCEPTED_TYPES = [
    'image/jpeg',
    'image/png',
    'image/webp',
    'image/gif',
    'image/avif',
    'image/svg+xml',
];
export const IMAGE_UPLOAD_MAX_BYTES = 10 * 1024 * 1024;
/** An SVG is markup: a logo is kilobytes, so megabytes means something is wrong. */
export const SVG_UPLOAD_MAX_BYTES = 1024 * 1024;
export function validateImageForUpload(file) {
    if (!IMAGE_UPLOAD_ACCEPTED_TYPES.includes(file.type)) {
        return 'Solo JPEG, PNG, WebP, GIF, AVIF o SVG';
    }
    if (file.type === 'image/svg+xml') {
        return file.size > SVG_UPLOAD_MAX_BYTES
            ? `Máximo 1 MB para SVG (este: ${(file.size / 1024).toFixed(0)} KB)`
            : null;
    }
    if (file.size > IMAGE_UPLOAD_MAX_BYTES) {
        return `Máximo 10 MB (este: ${(file.size / 1024 / 1024).toFixed(1)} MB)`;
    }
    return null;
}
/** Shared browser uploader with real byte progress for editor and dashboard. */
export function uploadFormDataWithProgress({ url, formData, headers = {}, onProgress, }) {
    return new Promise((resolve, reject) => {
        const xhr = new XMLHttpRequest();
        xhr.open('POST', url);
        for (const [name, value] of Object.entries(headers))
            xhr.setRequestHeader(name, value);
        xhr.upload.onprogress = (event) => {
            if (!event.lengthComputable)
                return;
            onProgress?.(Math.round((event.loaded / event.total) * 100));
        };
        xhr.onload = () => resolve({ status: xhr.status, responseText: xhr.responseText });
        xhr.onerror = () => reject(new Error('Error de red al subir el archivo'));
        xhr.onabort = () => reject(new DOMException('Upload aborted', 'AbortError'));
        xhr.send(formData);
    });
}
//# sourceMappingURL=upload.js.map